import React, { useContext, useState } from "react";
import ActionContext from "../../context/ActionContext";
import "./GridListViewSwitch.css";
import { RavenToolTip } from "@ravenpay/raven-bank-ui";

type manualSwitchValueProp = {
  label?: string;
  value?: string;
};

interface MyComponentProps {
  onManualSwitch?: (param: any) => void;
  manualSwitchValue?: manualSwitchValueProp;
  className?: string;
  style?: any;
}

const GridListViewSwitch = ({
  className,
  manualSwitchValue,
  onManualSwitch,
  style,
}: MyComponentProps) => {
  const actionCtx = useContext(ActionContext);

  const icons = {
    grid: (param?: string) => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            fill={param || "#D1D1D1"}
            d="M4.5 2.7a1.8 1.8 0 0 0-1.8 1.8v1.8a1.8 1.8 0 0 0 1.8 1.8h1.8a1.8 1.8 0 0 0 1.8-1.8V4.5a1.8 1.8 0 0 0-1.8-1.8zM4.5 9.9a1.8 1.8 0 0 0-1.8 1.8v1.8a1.8 1.8 0 0 0 1.8 1.8h1.8a1.8 1.8 0 0 0 1.8-1.8v-1.8a1.8 1.8 0 0 0-1.8-1.8zM9.9 4.5a1.8 1.8 0 0 1 1.8-1.8h1.8a1.8 1.8 0 0 1 1.8 1.8v1.8a1.8 1.8 0 0 1-1.8 1.8h-1.8a1.8 1.8 0 0 1-1.8-1.8zM9.9 11.7a1.8 1.8 0 0 1 1.8-1.8h1.8a1.8 1.8 0 0 1 1.8 1.8v1.8a1.8 1.8 0 0 1-1.8 1.8h-1.8a1.8 1.8 0 0 1-1.8-1.8z"
          ></path>
        </svg>
      );
    },
    table: (param?: string) => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            fill={param || "#D1D1D1"}
            fillRule="evenodd"
            d="M4.5 3.6a2.7 2.7 0 0 0-2.7 2.7v5.4a2.7 2.7 0 0 0 2.7 2.7h9a2.7 2.7 0 0 0 2.7-2.7V6.3a2.7 2.7 0 0 0-2.7-2.7zm-.9 8.1v-.9h4.5v1.8H4.5a.9.9 0 0 1-.9-.9m6.3.9h3.6a.9.9 0 0 0 .9-.9v-.9H9.9zm0-3.6h4.5V7.2H9.9zM8.1 7.2H3.6V9h4.5z"
            clipRule="evenodd"
          ></path>
        </svg>
      );
    },
  };

  const switchList = [
    {
      label: "grid",
      value: "grid-list",
      icon: icons?.grid(),
      activeIcon: icons?.grid("#ffffff"),
    },
    {
      label: "table",
      value: "table-list",
      icon: icons?.table(),
      activeIcon: icons?.table("#ffffff"),
    },
  ];

  return (
    <div
      className={`grid-list-view-switch-wrapper-box border-theme ${
        className ? className : ""
      }`}
    >
      {switchList?.map((chi, idx) => {
        return (
          <div
            key={idx}
            className={`switch-item ${
              chi?.value === actionCtx?.viewListMode?.value
                ? `switch-item-active`
                : ""
            }`}
            onClick={() => {
              if (chi?.value !== actionCtx?.viewListMode?.value) {
                actionCtx?.setViewListMode(chi);
                onManualSwitch && onManualSwitch(chi);
              }
            }}
          >
            {/* tooltip here start */}

            {/* tooltip here end */}
            <figure
              className={`img-box ${
                chi?.value !== actionCtx?.viewListMode?.value
                  ? "tooltip-hover-wrap"
                  : ""
              }`}
            >
              <RavenToolTip
                position="bottom-left"
                color="deep-green-light"
                text={`Switch to ${chi?.label} view`}
              />
              {chi?.value === actionCtx?.viewListMode?.value
                ? chi?.activeIcon
                : chi?.icon}
            </figure>
          </div>
        );
      })}
    </div>
  );
};

export default GridListViewSwitch;
